"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SortHelper = exports.EnumSortCompare = void 0;
var decorators_1 = require("../decorators");
var utils_1 = require("../utils");
var EnumSortCompare;
(function (EnumSortCompare) {
    EnumSortCompare[EnumSortCompare["LESS_THAN"] = -1] = "LESS_THAN";
    EnumSortCompare[EnumSortCompare["BIGGER_THAN"] = 1] = "BIGGER_THAN";
    EnumSortCompare[EnumSortCompare["EQUALS"] = 0] = "EQUALS";
})(EnumSortCompare = exports.EnumSortCompare || (exports.EnumSortCompare = {}));
var SortHelper = /** @class */ (function () {
    function SortHelper() {
    }
    SortHelper.prototype.bubbleSort = function (sortData, compareOptions) {
        // 获取数组长度
        var length = sortData.length;
        for (var i = 0; i < length; i++) {
            // 从数组的0号元素遍历到数组的倒数第2号元素，然后减去外层已经遍历的轮数
            for (var j = 0; j < length - 1 - i; j++) {
                // 如果j > j + 1位置的元素就交换他们两个元素的位置
                if (this.compare(sortData[j], sortData[j + 1], compareOptions === null || compareOptions === void 0 ? void 0 : compareOptions.compareValueKey, compareOptions === null || compareOptions === void 0 ? void 0 : compareOptions.compareFn) === EnumSortCompare.BIGGER_THAN) {
                    this.swap(sortData, j, j + 1);
                }
            }
        }
    };
    /**
     * 选择排序算法
     * @param sortData - 排序数据
     * @param compareOptions - [可选]排序参数
     */
    SortHelper.prototype.selectionSort = function (sortData, compareOptions) {
        var len = sortData.length;
        var minIndex = 0;
        for (var i = 0; i < len; i++) {
            minIndex = i;
            for (var j = i; j < len; j++) {
                if (this.compare(sortData[minIndex], sortData[j], compareOptions === null || compareOptions === void 0 ? void 0 : compareOptions.compareValueKey, compareOptions === null || compareOptions === void 0 ? void 0 : compareOptions.compareFn) === EnumSortCompare.BIGGER_THAN) {
                    minIndex = j;
                }
            }
            if (minIndex !== i) {
                this.swap(sortData, i, minIndex);
            }
        }
    };
    /**
     * 自定数组两个元素互相交换位置
     * @param sortData - 排序数组
     * @param index - 第一个交换元素
     * @param nextIndex - 第二个交换元素
     */
    SortHelper.prototype.swap = function (sortData, index, nextIndex) {
        var tmpData = sortData[index];
        sortData[index] = sortData[nextIndex];
        sortData[nextIndex] = tmpData;
    };
    /**
     * 比较两个变量大小，可使用两个对象中的指定字段做比较
     * @param a - 比较变量A
     * @param b - 比较变量B
     * @param compareValueKey - [可选]比较字段索引
     * @param compareCallback - [可选]自定义比较方法
     * @returns - 返回比较结果
     */
    SortHelper.prototype.compare = function (a, b, compareValueKey, compareCallback) {
        if (utils_1.utils.isEmpty(compareValueKey)) {
            if (typeof compareCallback === "function") {
                return compareCallback(a, b);
            }
            else {
                if (a === b) {
                    return EnumSortCompare.EQUALS;
                }
                else if (a > b) {
                    return EnumSortCompare.BIGGER_THAN;
                }
                else {
                    return EnumSortCompare.LESS_THAN;
                }
            }
        }
        else {
            var compareA = utils_1.utils.getValue(a, compareValueKey);
            var compareB = utils_1.utils.getValue(b, compareValueKey);
            if (typeof compareCallback === "function") {
                return compareCallback(compareA, compareB);
            }
            else {
                if (compareA === compareB) {
                    return EnumSortCompare.EQUALS;
                }
                else if (compareA > compareB) {
                    return EnumSortCompare.BIGGER_THAN;
                }
                else {
                    return EnumSortCompare.LESS_THAN;
                }
            }
        }
    };
    SortHelper = __decorate([
        decorators_1.Service
    ], SortHelper);
    return SortHelper;
}());
exports.SortHelper = SortHelper;
